import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { IPlanWeek } from "../../../domain/models/plan/plan-week.model";

/** The week strip above the board: every week of the plan, scrolled with the two arrows. */
@Component({
  selector: "app-planner-week-pager",
  templateUrl: "./planner-week-pager.component.html",
  styleUrl: "./planner-week-pager.component.scss",
})
export class PlannerWeekPagerComponent {
  @Input() weeks: IPlanWeek[] = [];
  @Input() selectedWeekId?: number | null;

  @Output() weekSelected = new EventEmitter<IPlanWeek>();

  @ViewChild("strip") strip?: ElementRef<HTMLElement>;

  scroll(direction: -1 | 1) {
    const strip = this.strip?.nativeElement;
    if (!strip) {
      return;
    }

    strip.scrollBy({ left: direction * Math.round(strip.clientWidth * 0.8), behavior: "smooth" });
  }
}
